// extracted by mini-css-extract-plugin
export default {"container":"spinning-loader_container__49A+H","truncate-table":"spinning-loader_truncate-table__kKCln","table-text-faded":"spinning-loader_table-text-faded__9kW8C","spinningLoader":"spinning-loader_spinningLoader__KD-Gg"};
    if(module.hot) {
      // 1793877086053
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  